import React from 'react';
import logger from '#/utils/logger';
import './error-boundary.css';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
  componentStack: string | null;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null, componentStack: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logger.error('ErrorBoundary caught error:', error, info.componentStack);
    this.setState({ componentStack: info.componentStack ?? null });
  }

  render() {
    if (!this.state.error) return this.props.children;

    const { message, stack } = this.state.error;
    const { componentStack } = this.state;
    return (
      <div className="error-boundary">
        <div className="error-boundary-content">
          <h1>Apply latest update</h1>
          <p>Click to refresh and continue.</p>
          <button onClick={() => window.location.reload()}>Confirm changes</button>
          <details>
            <summary>Technical details</summary>
            <pre>{message}{componentStack ? `\n\nComponent stack:${componentStack}` : ''}{stack ? `\n\nJS stack:\n${stack}` : ''}</pre>
          </details>
        </div>
      </div>
    );
  }
}
